import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Divider, Box, styled } from '@mui/material';
import { NavLink } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InventoryIcon from '@mui/icons-material/Inventory';
import LayersIcon from '@mui/icons-material/Layers';
import { LogoutOutlined } from "@mui/icons-material";

const CompactNavItem = styled(ListItem)(({ theme }) => ({
    minHeight: 48,
    padding: theme.spacing(0.5, 2),
    margin: theme.spacing(0.5, 1),
    borderRadius: 8,
    '&.active': {
        backgroundColor: theme.palette.action.selected,
        '& .MuiListItemIcon-root': {
            color: theme.palette.primary.main,
        },
        '& .MuiTypography-root': {
            fontWeight: 500,
        }
    },
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    }
}));

const Sidebar = () => {
    return (
        <Box sx={{ width: 200, bgcolor: 'background.paper', height: '100vh', p: 1 }}>
            <List dense disablePadding>
                <CompactNavItem
                    component={NavLink}
                    to="/"
                    exact
                    activeClassName="active"
                >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                        <DashboardIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                        primary="Dashboard"
                        primaryTypographyProps={{ fontSize: 14 }}
                    />
                </CompactNavItem>

                <CompactNavItem
                    component={NavLink}
                    to="/products"
                    activeClassName="active"
                >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                        <InventoryIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                        primary="Products"
                        primaryTypographyProps={{ fontSize: 14 }}
                    />
                </CompactNavItem>

                <CompactNavItem
                    component={NavLink}
                    to="/bundles"
                    activeClassName="active"
                >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                        <LayersIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                        primary="Bundles"
                        primaryTypographyProps={{ fontSize: 14 }}
                    />
                </CompactNavItem>
            </List>

            <Divider sx={{ my: 1 }} />

            <List dense disablePadding>
                <CompactNavItem button>
                    <ListItemIcon sx={{ minWidth: 40 }}>
                        <LogoutOutlined fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                        primary="Logout"
                        primaryTypographyProps={{ fontSize: 14 }}
                    />
                </CompactNavItem>
            </List>
        </Box>
    );
};

export default Sidebar;